import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe7e13de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-tracker-confirm-popover__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-time-tracker-confirm-popover__title" }, "Запустить новый таймер?", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-time-tracker-confirm-popover__description" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "task-time-tracker-confirm-popover__description-part" }, " У вас уже запущен таймер на другом тикете. "),
  /*#__PURE__*/_createElementVNode("p", { class: "task-time-tracker-confirm-popover__description-part" }, " Если запустите новый, старый таймер будет остановлен ")
], -1))
const _hoisted_4 = { class: "task-time-tracker-confirm-popover__buttons" }

import { computed, ref } from "vue";
import {
  TirPmPopover,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-tracker-confirm-popover',
  props: {
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["confirm"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Ссылка на компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

const customPosition = computed(() => {
  return {
    right: "0.75rem",
    bottom: "3.75rem",
  };
});

__expose({
  open: () => $popover.value?.open(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    class: "task-time-tracker-confirm-popover",
    ref_key: "$popover",
    ref: $popover,
    "custom-position": customPosition.value,
    width: "19.625rem"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
            "is-loading": __props.isLoading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Запустить новый таймер ")
            ]),
            _: 1
          }, 8, ["size", "variant", "is-loading"]),
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            onClick: $popover.value?.close
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          }, 8, ["size", "variant", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "task-time-tracker-confirm-popover__target",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      })
    ]),
    _: 1
  }, 8, ["custom-position"]))
}
}

})